import { DesktopDatePicker } from '@mui/x-date-pickers';
import '@mui/lab';
import { Button, Dialog, DialogContent, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { BoxFC, BoxFR } from "components/BoxCustom";
import CheckboxFormControl from "components/CheckboxFormControl";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import ModAccName from "components/ModAccName";
import PaperComponent from "components/PaperComponent";
import { paymentVoucherColNm } from "constants/paymentVoucherConstant";
import React, { useContext } from "react";
import { useMemo } from "react";
import { useCallback } from "react";
import { generateMenuItemWithNull, numberFormat, validate } from "utils";
import {  scPvInvColumns } from "./columns";
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
// import useFinanceMsData from "hooks/useFinanceMsData";
import FileUpload from "components/FileUplaod/FileUpload";
import useSubcontractPaymentVoucherDialog from "./useSubcontractPaymentVoucherDialog";
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import SubcontractPaymentVoucherReportDialog from "./SubcontractPaymentVoucherReportDialog";
import { GlobalStateContext } from 'contexts/GlobalStateContext';

const SubcontractPaymentVoucherDialog = ({ selectedRows, selectedId, dialogOpen, setDialogOpen, onFinish }) => {

  const { msData } = useContext(GlobalStateContext)
  // const { msData } = useFinanceMsData();

  const { state, fn } = useSubcontractPaymentVoucherDialog({ selectedRows, selectedId, dialogOpen, setDialogOpen, onFinish })
  const { scPVData, scInvTable, fileUploadData, sumData, pvReportDialogOpen } = state

  const validation = useMemo(() => ({
    PVNo: scPVData.PVNo === "",
    PVDte: scPVData.PVDte === null,
  }), [scPVData]);

  const pvDteProp = useCallback((name, isRequired, width) => ({
    label: paymentVoucherColNm[name],
    inputFormat: "DD/MM/YYYY",
    mask: "__/__/____",
    value: scPVData[name],
    onChange: (newValue) => { fn.setScPVData(o => ({ ...o, [name]: newValue })) },
    renderInput: (params) => <TextField {...params} size="small" sx={{ width: width }} error={isRequired && validation[name]} required={isRequired} />,
  }), [ fn, scPVData, validation])

  const pvDataProp = useCallback((name, readonly, isSetNull) => ({
    size: "small", varaint: "outlined", label: paymentVoucherColNm[name],
    required: name === "ScInvNo",
    value: isSetNull ? scPVData[name] ?? "" : scPVData[name],
    onChange: (e) => readonly ? null : fn.setScPVData(o => ({ ...o, [name]: e.target.value || null }))
  }), [scPVData, fn])

  const pvCurrencyProp = useCallback((name, readonly) => ({
    size: "small", varaint: "outlined",
    inputProps: { style: { textAlign: 'right' } },
    InputProps: { endAdornment: <InputAdornment position="end">บาท</InputAdornment> },
    value: numberFormat(sumData[name]),
    onChange: (e) => readonly ? null : fn.setScPVData(o => ({ ...o, [name]: e.target.value }))
  }), [ fn, sumData])

  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="false"
      PaperProps={{
        style: {
          minHeight: '90%',
          maxHeight: '90%',
        }
      }}>
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายได้ Invoice รถร่วม"
        onDeleteClick={selectedId > 0 ? () => fn.deleteSubcontractPaymentVoucher() : null}
      />
      <DialogContent sx={{ display: "flex", gap: 2 }}>
        <BoxFR gap={1} mt={2} flex={1} sx={{ alignItems: "stretch" }}>
          <BoxFC width="100%">
            <Typography variant="h6"> ข้อมูลใบแจ้งหนี้รถร่วม {scPVData?.Sc?.Name}</Typography>
            <Box width="100%" mt={-1} flex={1}  >
              <DataGridCellExpand
                hideFooter
                rows={scInvTable}
                columns={scPvInvColumns} />
            </Box>
            <BoxFC sx={{ gap: 1 }} pl={2} alignItems="flex-end">
              <BoxFR justifyContent="space-between">
                <Typography>ยอดรวมใบเสร็จบริษัท</Typography>
                <TextField {...pvCurrencyProp("OwnRcptAmnt", true)} />
              </BoxFR>
              <BoxFR justifyContent="space-between">
                <Typography>ยอดรวมใบเสร็จลูกค้า</Typography>
                <TextField {...pvCurrencyProp("CusRcptAmnt", true)} />
              </BoxFR>
              <BoxFR justifyContent="space-between">
                <Typography>ยอดรวมใบแจ้งหนี้</Typography>
                <TextField {...pvCurrencyProp("Total", true)} />
              </BoxFR>
              <BoxFR justifyContent="space-between">
                <Typography>ยอดรวมหัก ณ ที่จ่าย</Typography>
                <TextField {...pvCurrencyProp("WhtPr", true)} />
              </BoxFR>
              <BoxFR justifyContent="space-between">
                <Typography>ยอดจ่าย</Typography>
                <TextField {...pvCurrencyProp("PayAmnt", true)} />
              </BoxFR>
            </BoxFC>
          </BoxFC>

          <Paper elevation={3} sx={{ width: 850, p: 2 }}>
            <BoxFC sx={{ height: "100%", gap: 1 }}>
              <Typography variant="h6">ใบสำคัญจ่าย</Typography>
              <BoxFR >
                <TextField {...pvDataProp("PVNo")} error={validation.PVNo} sx={{ width: 200 }} disabled={selectedId!==0}/>
                <Button variant="contained" onClick={fn.generagePVNo} disabled={selectedId!==0}>GEN</Button>
                <Box flex={1} />
                <DesktopDatePicker {...pvDteProp("PVDte", true, 200)} disabled={selectedId!==0}/>
              </BoxFR>
              <BoxFR>
                <TextField {...pvDataProp("Rmk")} sx={{ flex: 1 }} />
                {
                  selectedId > 0 &&
                  <Button variant="contained" onClick={fn.handleOpenReportDialog}><PrintRoundedIcon sx={{mr:1}}/> รายงานการจ่ายเงิน</Button>
                }
              </BoxFR>
              <Typography variant="h6">รายละเอียดการจ่ายเงิน</Typography>
              <BoxFR >
                <TextField {...pvDataProp("PayMthdId", false, true)} select sx={{ width: 150 }}>
                  {generateMenuItemWithNull(msData.payMethodCombo)}
                </TextField>
                {scPVData.PayMthdId === 2 && <DesktopDatePicker {...pvDteProp("ChqDte", false, 228)} />}
                <Box flex={1} />
                <Button variant="contained" onClick={fn.handlePayAll} sx={{px:1, width: 110}}>จ่ายเต็มจำนวน</Button>
              </BoxFR>
              {scPVData.PayMthdId === 2 &&
                <BoxFR>
                  <TextField {...pvDataProp("ChqBkId", false, true)} select sx={{ width: 150 }}>
                    {generateMenuItemWithNull(msData.bankCombo)}
                  </TextField>
                  <TextField {...pvDataProp("ChqBrch", false, true)} sx={{ width: 100 }} />
                  <TextField {...pvDataProp("ChqNo", false, true)} sx={{ width: 120 }} />
                  <Box flex={1} />
                  <TextField {...pvDataProp("ChqAmnt", false, true)} sx={{ width: 110 }}
                    inputProps={{ style: { textAlign: 'right' } }} type="number" />
                </BoxFR>
              }
              {scPVData.PayMthdId === 3 &&
                <BoxFR>
                  <TextField {...pvDataProp("TrnBkId", false, true)} select sx={{ width: 150 }}>
                    {generateMenuItemWithNull(msData.bankCombo)}
                  </TextField>
                  <TextField {...pvDataProp("TrnBkBrch", false, true)} sx={{ width: 100 }} />
                  <TextField {...pvDataProp("TrnBkAccNo", false, true)} sx={{ width: 120 }} />
                  <TextField {...pvDataProp("TrnAccNm", false, true)} sx={{ flex:1 }} />
                </BoxFR>
              }
              <BoxFR>
                <TextField {...pvDataProp("BkAccId", false, true)} select onChange={fn.handleBkAccIdChange}
                  sx={{ width: 150 }} label="บัญชีจ่าย">
                  {generateMenuItemWithNull(msData.bankAccountCombo)}
                </TextField>
                <TextField {...pvDataProp("BBNo", false, true)} sx={{ width: 228 }} />
                <Box flex={1} />
                <TextField {...pvDataProp("FeeAmnt", false)} type="number"
                  sx={{ width: 110 }} inputProps={{ style: { textAlign: 'right' } }} />
              </BoxFR>
              <BoxFR>
                <DesktopDatePicker {...pvDteProp("PayDte", false, 150)} />
                <TextField {...pvDataProp("BBPage", false, true)} sx={{ width: 60 }}
                  inputProps={{ style: { textAlign: 'center' } }} value={scPVData.BBPage || ""}
                  onChange={(e) => fn.setScPVData(o => ({ ...o, BBPage: e.target.value || null }))} />
                <TextField {...pvDataProp("BBRow", false, true)} sx={{ width: 60 }}
                  inputProps={{ style: { textAlign: 'center' } }} value={scPVData.BBRow || ""}
                  onChange={(e) => fn.setScPVData(o => ({ ...o, BBRow: e.target.value || null }))} />
                <Box flex={1} />
                <TextField {...pvDataProp("PayAmnt", false)} sx={{ width: 110 }} type="number"
                  inputProps={{ style: { textAlign: 'right' } }} />
              </BoxFR>
              <BoxFR>
                <TextField {...pvDataProp("DiffDscp", false)} sx={{ width: 386 }} />
                <Box flex={1}/>
                <TextField {...pvDataProp("DiffAmnt", false)} sx={{ width: 110 }}
                  inputProps={{ style: { textAlign: 'right' } }}
                  value={numberFormat(+scPVData.PayAmnt - +sumData.PayAmnt)} onChange={null}></TextField>
              </BoxFR>

              <CheckboxFormControl label="การชำระเงินเสร็จสมบูรณ์" checked={scPVData.IsCmpt ? true : false}
                onChange={(e) => fn.setScPVData(o => ({ ...o, IsCmpt: e.target.checked }))}
                checkedIcon={<PlaylistAddCheckCircleIcon />} />
                <Box flex={1}>
              <FileUpload
                options={msData.serverData.PreText.InvoiceFiles || []}
                fileUploadData={fileUploadData}
                setFileUploadData={fn.setFileUploadData} />
              <Box />
                </Box>
              {
                selectedId > 0 && <ModAccName modDte={scPVData.ModDte} modAcc={scPVData.ModAcc} />
              }
            </BoxFC>
          </Paper>
        </BoxFR>
        <SubcontractPaymentVoucherReportDialog 
          selectedId={selectedId}
          dialogOpen={pvReportDialogOpen} 
          setDialogOpen={fn.setPVReportDialogOpen}/>
      </DialogContent>

      <DialogFooter okText="บันทึกข้อมูล"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={() => validate(validation) && fn.insertUpdateSubcontractPaymentVoucher() } />
    </Dialog>
  )
}

export default React.memo(SubcontractPaymentVoucherDialog)

